const YEAR = new Date().getFullYear()

export function Footer() {
  return (
    <footer className="mt-16 border-t border-line bg-sunken">
      <div className="mx-auto flex max-w-[1600px] flex-col items-center justify-between gap-3 px-4 py-6 text-sm sm:flex-row sm:px-6">
        <p className="flex items-center gap-2 text-muted">
          <img src="/sighthub-logo.png" alt="" width={18} height={18} className="size-[18px] object-contain" />
          Powered by{' '}
          <a
            href="https://sighthub.cloud"
            className="font-medium text-accent-text hover:underline"
          >
            SightHub
          </a>
        </p>

        <p className="text-subtle">© {YEAR} SightHub INC. All rights reserved.</p>
      </div>
    </footer>
  )
}
